import { Layer, Source } from "react-map-gl/mapbox"

interface ABFLayerProps {
  opacity?: number
}

export const ABFLayer = ({ opacity = 0.5 }: ABFLayerProps) => {
  return (
    <>
      <Source
        id="raster-abf"
        type="raster"
        tiles={[
          "https://data.geopf.fr/wms-v/ows?SERVICE=WMS&VERSION=1.3.0&REQUEST=GetMap&FORMAT=image/png&TRANSPARENT=true&LAYERS=monument_historique&WIDTH=256&HEIGHT=256&CRS=EPSG:3857&STYLES=&bbox={bbox-epsg-3857}",
        ]}
        tileSize={256}
      >
        <Layer id="raster-abf" type="raster" source="raster-abf" paint={{ "raster-opacity": opacity }} />
      </Source>
      <Source
        id="raster-abf-patrimoine"
        type="raster"
        tiles={[
          "https://data.geopf.fr/wms-v/ows?SERVICE=WMS&VERSION=1.3.0&REQUEST=GetMap&FORMAT=image/png&TRANSPARENT=true&LAYERS=patrimoine_architectural&WIDTH=256&HEIGHT=256&CRS=EPSG:3857&STYLES=&bbox={bbox-epsg-3857}",
        ]}
        tileSize={256}
      >
        <Layer
          id="raster-abf-patrimoine"
          type="raster"
          source="raster-abf-patrimoine"
          paint={{ "raster-opacity": opacity }}
        />
      </Source>
    </>
  )
}
